import uniq from 'lodash/uniq';
import { queryHashGenerator } from '../../../utils/queryHash';
import { ICrossTestMetricSelection, ISelectableEntity } from '../../types';

/**
 * @description gathers unique query hashes from a list of cross test metric selections
 * @param metrics
 * @returns
 */
export const gatherQueryHashes = (
  metrics: ICrossTestMetricSelection[]
): string[] => {
  return uniq(
    metrics?.map((m: ICrossTestMetricSelection): string =>
      queryHashGenerator(
        m.testType.value,
        m.tags?.map((se: ISelectableEntity): string => se.value)
      )
    ) ?? []
  );
};
